import React, { createContext, useState } from "react";

// ToastContext oluşturuyoruz
const ToastContext = createContext();

// Sağlayıcı bileşen
export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  // Toast gösterme fonksiyonu
  const showToast = (message, type = "Info") => {
    setToast({ show: true, message, type });

    // Toast'u 3 saniye sonra gizle
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  return (
    <ToastContext.Provider value={{ toast, showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastContext;
